import { FC } from 'react';

import { cn } from '@/shared/libs/utils/cn';

interface LoaderOverlayProps {
  show: boolean;
  fixed?: boolean;
}

export const LoaderOverlay: FC<LoaderOverlayProps> = ({ fixed, show }) => {
  if (!show) return null;

  return (
    <div
      className={cn(
        fixed ? 'fixed' : 'absolute',
        'inset-0 z-50 bg-background/80 backdrop-blur-sm',
        'flex items-center justify-center',
      )}>
      <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-primary" />
    </div>
  );
};
